import { render, staticRenderFns } from "./rituals.vue?vue&type=template&id=322edd4c&scoped=true"
import script from "./rituals.vue?vue&type=script&lang=js"
export * from "./rituals.vue?vue&type=script&lang=js"
import style0 from "./rituals.vue?vue&type=style&index=0&id=322edd4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322edd4c",
  null
  
)

export default component.exports